import IOption from "common/models/IOption";
import { ID } from "./IEntity";
import { IGroup } from "./IGroup";


export enum Type {
	ALERT = "Alert",
	ANNOUNCEMENT = "Announcement",
	INFO = "Info",
	REMINDER = "Reminder",
	CRITICAL = "Critical"
}

export enum Sort {
	startDate = "-startDate",
	name = "name",
	
}

export const typeOptions: Array<IOption<Type>> = [
	{value: Type.ANNOUNCEMENT, label: "Announcement"},
	{value: Type.INFO, label: "Info"},
	{value: Type.REMINDER, label: "Reminder"},
	{value: Type.ALERT, label: "Alert"},
	{value: Type.CRITICAL, label: "Critical"}
];

export interface IMessage {
	id: ID;
	type: Type;
	name: string;
	summary?: string;
	startDate?: string;
	endDate?: string;
	targetGroups?: IGroup[];
}


export const sort : Array<IOption<Sort>> = [
	{value: Sort.startDate, label: "Start Date"},
	{value: Sort.name, label: "Name"},
];


// WEBPACK FOOTER //
// ./src/common/entities/IMessage.ts